export default __webpack_public_path__ + "images/apply-refill-ico.svg";